const ROUTES = {
  // Public Routes
  INVITE: "/invite",
  PRIVACY_POLICY: "/privacy-policy",
  AUTH_ACTION: "/auth/action",
  BROWSER_AUTHORIZE: "/browser/authorize",

  // Auth Routes
  LOGIN: "/",

  // Protected Routes
  SPARKS_DASH: "/spark",
  CHAT: {
    ROOT: "/chat",
    BY_ID: "/chat/:id",
  },

  SPECTRA: {
    ROOT: "/spectra",
    CREATE: "/spectra/create",
    LANDING: "/spectra/:space_id",
    EDIT: "/spectra/:space_id/edit",
    CHAT: "/spectra/:space_id/chat",
    CHAT_BY_ID: "/spectra/:space_id/chat/:id",
  },


  // AGENTS: {
  //   ROOT: "/agents",
  //   CHAT: "/agents/:agent/chat",
  //   CHAT_BY_ID: "/agents/:agent/chat/:chat_id",
  //   DASHBOARD: "/agents/dashboard/:id",
  // },

  FORGE: {
    ROOT: "/forge",
    ADD_PROVIDER: "/forge/add-provider",
    ADD_AGENT: "/forge/add-agent",
    EDIT_PROVIDER: "/forge/edit-provider/:providerId",
    EDIT_AGENT: "/forge/edit-agent/:agentId",
  },

  SETTINGS: {
    ROOT: "/settings",
    PROFILE: "/settings/profile",
    MODELS: "/settings/models",
    MODELS_CATALOG: "/settings/models/catalog",
    MODELS_CONFIG: "/settings/models/config",
    MODELS_PROVIDERS: "/settings/models/providers",
    FORGE_PROVIDERS: "/settings/forge-providers",
    FORGE_PROVIDER_ADD: "/settings/forge-providers/new",
    FORGE_PROVIDER_EDIT: (providerId) => `/settings/forge-providers/${providerId}`,
    FORGE_AGENTS_LEGACY: "/settings/forge-agents",
    USERS: "/settings/users",
    GROUPS: "/settings/groups",
    // Legacy paths — redirected to identity sub-section
    GW_CONFIG: "/settings/google-workspace",
    SCIM_CONFIG: "/settings/scim",
    SSO_PROVIDERS: "/settings/sso",
    // Identity sub-section
    IDENTITY: "/settings/identity",
    IDENTITY_SSO: "/settings/identity/sso",
    IDENTITY_DIRECTORY: "/settings/identity/directory",
    IDENTITY_SCIM: "/settings/identity/scim",
    IDENTITY_BREAK_GLASS: "/settings/identity/break-glass",
    SCHEDULED_JOBS: "/settings/scheduled-jobs",
    ADMIN_SCHEDULED_JOBS: "/settings/admin-scheduled-jobs",
    APPS: "/settings/apps",
    APPS_DETAIL: (clientId) => `/settings/apps/${clientId}`,
    AUDIT_EXPORTS: "/settings/audit",
    FINOPS: "/settings/finops",
    AUDIT_LOG: "/settings/audit-log",
    DESKTOP: "/settings/desktop",
    DESKTOP_BRIDGE_LEGACY: "/settings/desktop-bridge",
    // Config sub-section
    CONFIG: "/settings/config",
    CONFIG_GENERAL: "/settings/config/general",
    CONFIG_AUTH: "/settings/config/auth",
    CONFIG_EMAIL: "/settings/config/email",
    CONFIG_SCHEDULER: "/settings/config/scheduler",
    CONFIG_GLUON: "/settings/config/gluon",
    CONFIG_SANDBOX: "/settings/config/sandbox",
    CONFIG_REALTIME: "/settings/config/realtime",
    CONFIG_DESKTOP: "/settings/config/desktop",
    CONFIG_MEDIA: "/settings/config/media",
    CONFIG_STORAGE: "/settings/config/storage",
    CONFIG_LOGGING: "/settings/config/logging",
    CONFIG_CACHE: "/settings/config/cache",
    CONFIG_TELEMETRY: "/settings/config/telemetry",
  },
};

// Helper functions for dynamic route generation
export const ROUTE_HELPERS = {
  chat: {
    byId: (id) => `/chat/${id}`,
  },

  spectra: {
    create: () => `/spectra/create`,
    landing: (spaceId) => `/spectra/${spaceId}`,
    edit: (spaceId) => `/spectra/${spaceId}/edit`,
    chat: (spaceId) => `/spectra/${spaceId}/chat`,
    chatById: (spaceId, chatId) => `/spectra/${spaceId}/chat/${chatId}`,
  },

  // agents: {
  //   chat: (agentId) => `/agents/${agentId}/chat`,
  //   chatById: (agentId, chatId) => `/agents/${agentId}/chat/${chatId}`,
  //   dashboard: (id) => `/agents/dashboard/${id}`,
  // },

  settings: {
    models: () => `/settings/models`,
    forgeProviders: () => `/settings/forge-providers`,
    users: () => `/settings/users`,
    scheduledJobs: () => `/settings/scheduled-jobs`,
  },
  forge: {
    root: () => `/forge`,
    addProvider: () => `/forge/add-provider`,
    addAgent: () => `/forge/add-agent`,
    editProvider: (providerId) => `/forge/edit-provider/${providerId}`,
    editAgent: (agentId) => `/forge/edit-agent/${agentId}`,
  },
};

export default ROUTES;
